// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.link_component {
  padding: 10px;
  font-size: 1rem;
}
.link_component a:hover {
  color: #ff914e;
  transition: all 0.2s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/components/common/links/linkfield.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,eAAA;AACJ;AACQ;EACI,cAAA;EACA,gCAAA;AACZ","sourcesContent":[".link_component {\n    padding: 10px;\n    font-size: 1rem;\n    a {\n        &:hover {\n            color: #ff914e;\n            transition: all .2s ease-in-out;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
